import React from 'react'
import styled from 'styled-components'

import BannerNav from '../BannerNav'
import { episodes } from '../../data'
import Headline from '../Headline'
import Episode from '../Episode'

const Body = styled.div`
  background: white;
  color: black;
  padding-top: 2rem;
`
const Section = styled.section`
  margin-top: 1rem;
  &:not(:last-child) { margin-bottom: 6rem; }
  padding: 1rem;
`

export default () => (
  <div>
    <BannerNav right="😎 Members Area 😎"/>
    <Body>
      { episodes.reverse().map((ep, i) => (
        <Section key={i}>
          <Headline above={`Episode ${ep.number} — ${ep.releaseDate}`} prerelease={ep.unreleased}>
            { ep.title }
          </Headline>
          <Episode ep={ep}/>
        </Section>
      )) }
    </Body>
  </div>
)



/** WEBPACK FOOTER **
 ** ./src/components/Members/MembersPage.js
 **/